import { render, staticRenderFns } from "./rsv-dtls.vue?vue&type=template&id=1e8fd8a4&scoped=true&lang=pug&"
import script from "./rsv-dtls.vue?vue&type=script&lang=js&"
export * from "./rsv-dtls.vue?vue&type=script&lang=js&"
import style0 from "./rsv-dtls.vue?vue&type=style&index=0&id=1e8fd8a4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8fd8a4",
  null
  
)

export default component.exports